<template>
  <div class="bg auth-screen">
    <div class="container pt-120">
      <div class="card">
        <div class="card-body">
          <h2 class="card-title">Forgot Username</h2>
          <div class="card-description">
            To retrieve your username, first enter your email below to obtain your verification code.
          </div>
          <form>
            <div class="form-group">
              <label>Email</label>
              <input
                type="email"
                v-validate="'required|email'"
                name="email"
                :class="{
                  input: true,
                  'is-danger': errors.has('email'),
                  'is-success': !errors.has('email')
                }"
                class="form-control form-control-lg"
                v-model="user.email"
                placeholder="Enter your email address"
                required
              />
              <span v-show="errors.has('email')" class="text-danger">{{ errors.first("email") }}</span>
            </div>
            <p class="text-danger" v-if="errorMsg">{{ errorMsg }}</p>
            <div class="form-group">
              <div>
                <button type="submit" class="btn btn-primary btn-block" :disabled="errors.any() || !isCompleted" v-on:click.prevent="requestUsername" v-translate:rsb_submit="lang">
                  Submit
                </button>
              </div>
            </div>
          </form>
          <div class="footer-links">
            <router-link :to="{ name: 'login' }">Back to sign in</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

const dict = {
  custom: {
    email: {
      email: "Please enter a valid email address."
    }
  }
};

export default {
  name: "forgotUsername",
  data() {
    return {
      user: {
        email: ""
      },
      errorMsg: null
    };
  },
  watch: {
    user: {
      handler() {
        this.errorMsg = null;
      },
      deep: true
    }
  },
  computed: {
    isCompleted() {
      return this.user.email != "";
    },
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    }
  },
  mounted() {
    this.$validator.localize("en", dict);
    this.userLogout();
  },
  methods: {
    ...mapActions(["userLogout"]),
    requestUsername() {
      this.$api
        .forgotUsernameFact({
          email: this.user.email
        })
        .then(
          response => {
            if (response.body.message) {
              const paramsObj = {
                token: response.body.message.token
              };
              if (response.body.message.phone_number && response.body.message.phone_number != "") {
                paramsObj.mobile = response.body.message.phone_number;
              }

              this.$router.push({
                name: "verify-identity",
                params: paramsObj,
                query: {
                  tokenType: "FORGOT_USERNAME_OTP"
                }
              });
            }
          },
          error => {
            if (error.body.errorMessage == "USER_DOES_NOT_HAVE_USERNAME") {
              this.$swal({
                customClass: "no-username",
                title: error.body.message,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#b8c7ce",
                cancelButtonColor: "#34537d",
                confirmButtonText: "Cancel",
                cancelButtonText: "Yes"
              }).then(({ dismiss }) => {
                if (dismiss === "cancel") {
                  this.requestCreateUsernameToken();
                }
              });
            } else {
              this.errorMsg = error.body && error.body.message ? error.body.message : "Error while requesting to send forgot password";
            }
          }
        );
    },
    requestCreateUsernameToken() {
      this.$api
        .getTokenToCreateUsername({
          email: this.user.email
        })
        .then(
          response => {
            if (response.body.message) {
              const paramsObj = {
                token: response.body.message.token
              };
              if (response.body.message.phone_number && response.body.message.phone_number != "") {
                paramsObj.mobile = response.body.message.phone_number;
              }

              this.$router.push({
                name: "verify-identity",
                params: paramsObj,
                query: {
                  tokenType: "CREATE_USERNAME_OTP"
                }
              });
            }
          },
          error => {
            this.errorMsg = error.body && error.body.message ? error.body.message : "Error while requesting to change the password";
          }
        );
    }
  }
};
</script>

<style scoped lang="scss" src="@/assets/auth-screen.scss"></style>
